import { ApiBind, Common } from './common.model';

export class ResetPassword extends Common {

  @ApiBind({ column: 'user_name' })
  userName: string;

  @ApiBind({ column: 'email' })
  email: string;

  @ApiBind({ column: 'mfa_code1' })
  mfaCode1: number;

  @ApiBind({ column: 'mfa_code2' })
  mfaCode2: number;
}
